module.exports = __webpack_public_path__ + "img/fotofamiliar.3a1f0d0f.png";